import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useTranslation } from 'react-i18next';
import { Accordion, Card, Button, Row } from 'react-bootstrap';
import moment from 'moment';
import { isEmpty } from 'lodash';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import DamListCard from '../../../../Components/Card/DamListCard/DamListCard';
import Loader from '../../../../Components/Utility/Loader/Loader';
import { archiveUnarchiveFolders, deleteDamFolderGroupByIdAction, fetchDamAcrhivedFolder, filterFolderSortData } from '../store/DamFolder.action';
import { useDamFolderModuleState } from '../Provider';
import ConfirmationPopup from '../../../../Components/ModalPopup/ConfirmationPopup';

function AcrhivedFolder({ isSelectAll }) {
  const [selectedBomLibraryGroupId, setBomId] = useState(null);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const { DamFolderstate, setDamFolderState, damAddEditAccess, damDeleteAccess } = useDamFolderModuleState([]);
  const { selectedIdArray } = DamFolderstate;
  const location = useLocation();
  const [state, setState] = useState({
    damFolderGroupList: [],
    hasMore: true,
    loading: true,
    totalRecords: null,
    searchText: '',
    searchLoaded: false,
    archiveIds: [],
    activeAcrhiveModal: false,
    isArchiveState: false,
    archivedComment: '',
    activeList: 'folder',
    archivedList: [],
    binList: [],
    isOpen: false,
  });
  const { activeAcrhiveModal, archivedComment } = state;

  const {
    damFolderData: {
      filterValues: { pageIndex, pageSize, searchText },
      damFolderArchivedlist,
      totalAcrhivedCount,
    },
  } = useSelector((reduxState) => reduxState);

  useEffect(() => {
    if (Array.isArray(damFolderArchivedlist)) {
      setState((inInfinitestate) => ({
        ...inInfinitestate,
        archivedList: damFolderArchivedlist,
      }));
      setDamFolderState((prev) => ({ ...prev, archivedList: damFolderArchivedlist }));
    }
  }, [damFolderArchivedlist]);

  useEffect(() => {
    if (totalAcrhivedCount > damFolderArchivedlist.length) {
      setState((inInfinitestate) => ({
        ...inInfinitestate,
        hasMore: true,
      }));
    } else
      setState((inInfinitestate) => ({
        ...inInfinitestate,
        hasMore: false,
      }));
  }, [damFolderArchivedlist, totalAcrhivedCount]);

  useEffect(() => {
    const callFn = async () => {
      setState((prev) => ({ ...prev, loading: true }));
      const params = {
        pageIndex,
        pageSize,
        searchText,
      };
      await dispatch(fetchDamAcrhivedFolder(params));
      setState((prev) => ({ ...prev, loading: false }));
    };
    callFn();
    return () => {
      const obj = {
        pageIndex: 1,
      };
      dispatch(filterFolderSortData(obj));
    };
  }, [dispatch]);

  const handlePageNextInScroll = async () => {
    let index = pageIndex;
    index += 1;
    const params = {
      pageIndex: index,
      pageSize,
      searchText,
      totalRecords: totalAcrhivedCount,
      isScrolled: true,
    };
    const obj = {
      pageIndex: index,
      pageSize,
    };
    await dispatch(filterFolderSortData(obj));

    await dispatch(fetchDamAcrhivedFolder(params));
  };

  const handleOpenProductIdentifier = async () => {
    setState((prevData) => ({
      ...prevData,
      isOpen: !state.isOpen,
    }));
  };

  const onSelectCheckBox = async (e, id) => {
    let selectedItems = [...selectedIdArray];
    const findItems = selectedItems.filter((item) => item === id);
    if (findItems.length > 0) {
      selectedItems = selectedItems.filter((item) => item !== id);
      setDamFolderState((prev) => ({ ...prev, selectedIdArray: selectedItems }));
    } else {
      setDamFolderState((prev) => ({ ...prev, selectedIdArray: [...selectedItems, id] }));
    }
  };

  const archiveUnArchivedFn = (item) => {
    setState((prev) => ({
      ...prev,
      activeAcrhiveModal: !state?.isArchivedModal,
    }));
    setBomId(item);
  };

  const deleteDamFolderGroup = (id) => {
    setBomId(id);
    setShowConfirmationPopup(!showConfirmationPopup);
  };

  const deleteById = async () => {
    setState((prev) => ({
      ...prev,
      loading: true,
    }));
    const params = {};
    if (selectedBomLibraryGroupId) {
      params.damGroupId = [selectedBomLibraryGroupId];
    } else {
      params.damGroupId = [...selectedIdArray];
    }
    const res = await dispatch(deleteDamFolderGroupByIdAction(params, t));
    if (res) {
      setShowConfirmationPopup(!showConfirmationPopup);
      refreshPage();
    } else {
      setState((prev) => ({
        ...prev,
        loading: false,
      }));
    }
  };

  const refreshPage = async () => {
    setState((prev) => ({
      ...prev,
      loading: true,
      pageIndex: 1,
      damFolderGroupList: [],
      totalRecords: null,
      hasMore: true,
      searchText: '',
      searchLoaded: false,
    }));
    setDamFolderState((prev) => ({ ...prev, selectedIdArray: [] }));
    setBomId(null);
    const params = {
      pageIndex: 1,
      pageSize: state.pageSize,
      damFolderGroupList: [],
      totalRecords: null,
      isSelectAll: false,
      selectedIdArray: [],
    };

    await dispatch(fetchDamAcrhivedFolder(params));
  };

  const closeAcrhiveTrashDeleteModal = () => {
    setState((prev) => ({
      ...prev,
      activeAcrhiveModal: false,
      archiveIds: [],
    }));
  };

  const handleArchivedUnarchivedConfirmed = async () => {
    const params = { isArchived: location.state?.activeList === 'folder', archivedComment };
    if (selectedBomLibraryGroupId) {
      params.folderIds = [selectedBomLibraryGroupId];
    } else {
      params.folderIds = [...selectedIdArray];
    }
    const res = await dispatch(archiveUnarchiveFolders(params, t));
    if (res) {
      setState((prev) => ({
        ...prev,
        activeAcrhiveModal: false,
        // isArchiveState: false,
        archivedComment: '',
        archiveIds: [],
      }));
      refreshPage();
    } else {
      setState((prev) => ({
        ...prev,
        loading: false,
      }));
    }
  };

  const getFullName = (obj) => {
    return `${obj?.firstName} ${obj?.lastName}`;
  };

  useEffect(() => {
    if (state?.archivedList?.length > 0 && isSelectAll) {
      const selectedItems = [...selectedIdArray];
      // eslint-disable-next-line no-restricted-syntax
      for (const item of state.archivedList) {
        const findItems = selectedItems.filter((val) => val === item._id);
        if (findItems.length === 0) {
          selectedItems.push(item._id);
        }
      }
      setDamFolderState((prev) => ({ ...prev, selectedIdArray: selectedItems }));
    }
  }, [state?.archivedList, isSelectAll]);

  return (
    <div>
      <InfiniteScroll dataLength={state?.archivedList?.length} next={handlePageNextInScroll} hasMore={state?.hasMore} loader={state?.loading && <Loader />}>
        <div className="container-fluid my-3">
          {state.archivedList?.map((item, index) => (
            <Accordion defaultActiveKey="0" key={item._id}>
              <Card className="listing-card ">
                <Card.Header>
                  <div className="header-container">
                    <div className="header-left">
                      {location.state?.activeList !== 'bin' && (damAddEditAccess || damDeleteAccess) && (
                        <div className="checkbox-label">
                          <input
                            onChange={(e) => {
                              onSelectCheckBox(e, item._id);
                            }}
                            className="cursor-pointer"
                            name={`check_${index}`}
                            id={`check_${index}`}
                            type="checkbox"
                            checked={selectedIdArray?.filter((val) => val === item?._id).length > 0}
                          />
                          <label htmlFor={`check_${index}`} className="chklabel" />
                        </div>
                      )}
                      <strong className="ml-2">{item?.name}</strong>
                    </div>
                    <div className="header-right">
                      {damAddEditAccess && (
                        <button
                          type="submit"
                          className="btn px-1"
                          onClick={() => archiveUnArchivedFn(item?._id)}
                          title={item?.isArchived ? 'Unarchive' : 'Archive'}
                          aria-label={item?.isArchived ? 'Unarchive' : 'Archive'}
                        >
                          <i className="icon-server cursor-pointer top-padding" />
                        </button>
                      )}

                      {damDeleteAccess && (
                        <button
                          type="submit"
                          title="Bin"
                          className="btn px-1"
                          aria-label="Bin"
                          onClick={() => {
                            deleteDamFolderGroup(item._id);
                          }}
                        >
                          <i className="icon-delete cursor-pointer top-padding" />
                        </button>
                      )}
                      <div className="info-container xs-position-bottom iconfirst testing-action-spaceremoval placement-top">
                        <span className="icon-info" />
                        <div className="info-content text-nowrap">
                          <p className="text-right m-0">
                            <strong>{t('CUSTOM_MODULE.CREATED')} </strong> :{' '}
                            {`${typeof item?.createdBy === 'object' ? getFullName(item?.createdBy) : item?.createdBy} ${
                              item?.createdAt && moment(item?.createdAt).format('DD-MMMM-YYYY, HH:mm')
                            }`}
                          </p>

                          <p className="text-right m-0">
                            <strong>{t('CUSTOM_MODULE.MODIFIED')} </strong> :{' '}
                            {`${typeof item?.modifiedBy === 'object' ? getFullName(item?.modifiedBy) : item?.modifiedBy} ${
                              item?.updatedAt && moment(item?.updatedAt).format('DD-MMMM-YYYY, HH:mm')
                            }`}
                          </p>
                          {!isEmpty(item?.archivedComment) && (
                            <p className=" comment-box " style={{ margin: '2px' }}>
                              {item?.archivedComment}
                            </p>
                          )}
                        </div>
                      </div>
                      <Accordion.Toggle
                        className="text-decoration-none btn-toggle"
                        onClick={() => handleOpenProductIdentifier()}
                        as={Button}
                        variant="link"
                        eventKey="0"
                      >
                        {state.isOpen ? (
                          <span className="icon-new-down-arrow-icon dam-icon-dropdown " />
                        ) : (
                          <span className="icon-new-down-arrow-icon dam-transform-class " />
                        )}
                      </Accordion.Toggle>
                    </div>
                  </div>
                </Card.Header>

                <Accordion.Collapse eventKey="0">
                  <Card.Body className="py-3">
                    <Row>
                      {item?.files?.map((item, i) => (
                        <DamListCard
                          key={item?._id}
                          item={item}
                          index={i}
                          onDelete={() => {}}
                          onCheck={() => {}}
                          selectedIds={[]}
                          handleArchive={() => {}}
                          t={t}
                          activeList=""
                          isFolderArchived
                          damDeleteAccess={damDeleteAccess}
                          damAddEditAccess={damAddEditAccess}
                        />
                      ))}
                    </Row>
                    {item?.files?.length === 0 && <p className="text-center">{t('TAKING_DATES.NO_DATA_FOUND')}</p>}
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>
          ))}
          {state?.archivedList?.length === 0 && <p className="text-center">{t('TAKING_DATES.NO_DATA_FOUND')}</p>}
        </div>
      </InfiniteScroll>
      {showConfirmationPopup && (
        <ConfirmationPopup
          onOpen={showConfirmationPopup}
          onConfirm={deleteById}
          message={selectedBomLibraryGroupId?.length > 0 ? t('DAM_MAIN_VIEW.LISTING_VIEW.DAM_DELETE_GROUP') : t('DAM_MAIN_VIEW.LISTING_VIEW.DAM_DELETE_GROUPS')}
          title="Delete"
          toggle={() => setShowConfirmationPopup(!showConfirmationPopup)}
        />
      )}
      {activeAcrhiveModal && (
        <ConfirmationPopup
          onOpen={activeAcrhiveModal}
          onConfirm={handleArchivedUnarchivedConfirmed}
          title={
            location?.state?.activeList === 'folder'
              ? t('DAM_FOLDER_VIEW.LISTING_VIEW.ACRHIVE_DAM_FOLDER_TITLE')
              : t('DAM_FOLDER_VIEW.LISTING_VIEW.UNACRHIVE_DAM_FOLDER_TITLE')
          }
          message={`${t('DAM_MAIN_VIEW.LISTING_VIEW.ARE_YOU_SURE_YOU_WANT_TO')} ${
            location?.state?.activeList === 'folder' ? t('DAM_MAIN_VIEW.LISTING_VIEW.ARCHIVE') : t('DAM_MAIN_VIEW.LISTING_VIEW.UNARCHIVE')
          } ${t('DAM_MAIN_VIEW.LISTING_VIEW.THE_SELECTED_DAM_FOLDER')}`}
          toggle={closeAcrhiveTrashDeleteModal}
          isCommentOn
          comment={state?.archivedComment}
          commentText={(e) =>
            setState((prevState) => ({
              ...prevState,
              archivedComment: e.target.value,
            }))
          }
          fromSupplier
        />
      )}
    </div>
  );
}

export default AcrhivedFolder;
